import { create, type StateCreator } from 'zustand';
import { devtools } from 'zustand/middleware';
import { actions } from './actions/actions';
import {
    defaultSurveyState,
    defaultUiCoreQuestionFormState,
    defaultUiState,
} from './state-defaults';
import type {
    ActionsSlice,
    AnswerSlice,
    CardsSlice,
    CoreQuestionsSlice,
    StoreState,
    SurveySlice,
    UiCoreQuestionFormSlice,
    UiSlice,
} from './state-types';

/**
 * Zustand slices. Prettier ignores for readability.
 */

// prettier-ignore
const surveySlice: StateCreator<StoreState, [], [], SurveySlice> = () => ({
    survey: defaultSurveyState,
});

// prettier-ignore
const cardSlice: StateCreator<StoreState, [], [], CardsSlice> = () => ({
    cards: {},
});

// prettier-ignore
const answerSlice: StateCreator<StoreState, [], [], AnswerSlice> = () => ({
    answers: {},
});

// prettier-ignore
const coreQuestionsSlice: StateCreator<StoreState, [], [], CoreQuestionsSlice> = () => ({
    coreQuestions: {},
});

// prettier-ignore
const uiSlice: StateCreator<StoreState, [], [], UiSlice> = () => ({
    ui: defaultUiState,
});

// prettier-ignore
const uiCoreQuestionsSlice: StateCreator<StoreState, [], [], UiCoreQuestionFormSlice> = () => ({
    uiCoreQuestionForm: defaultUiCoreQuestionFormState,
});

// prettier-ignore
const actionsSlice: StateCreator<StoreState, [], [], ActionsSlice> = (set, get) => ({
    actions: actions(set, get),
});

const createStore: StateCreator<StoreState> = (...a) => ({
    ...surveySlice(...a),
    ...cardSlice(...a),
    ...answerSlice(...a),
    ...coreQuestionsSlice(...a),
    ...uiCoreQuestionsSlice(...a),
    ...uiSlice(...a),
    ...actionsSlice(...a),
});

export const useStore = create(
    devtools(createStore, { name: 'QQMS', store: 'QQMS' })
);
